<template>
  <employee-leaves-dashboard-view />
</template>

<script>
  export default {
    components: {
      EmployeeLeavesDashboardView: () => import('@/components/employee/leaves/dashboard/View'),
    },
    metaInfo () {
      return {
        title: 'Leave Dashboard',
      }
    },
  }
</script>
